import { metaverse } from "data/metaverse";
import { ethers } from "ethers";

export interface IToken {
  // ERC20
  totalSupply: () => Promise<number>;
  balanceOf: (address: string) => Promise<number>;
  transfer: (to: string, amount: number) => Promise<boolean>;
  allowance: (owner: string, spender: string) => Promise<number>;
  approve: (spender: string, amount: number) => Promise<boolean>;
  transferFrom: (from: string, to: string, amount: number) => Promise<boolean>;
  // ERC3009
  // transferWithAuthorization: () => Promise<void>;
  // Claimable
  claimOwner: () => Promise<string>;
  claim: (referral: string) => Promise<void>;
  withdraw: () => Promise<void>;
  // Utils
  usingSigner: () => boolean;
  addToken: (symbol: string, image: string) => Promise<void>;
}

export function DefaultToken(address: string, contractInterface: ethers.ContractInterface): Token {
  const node = new ethers.providers.JsonRpcProvider(metaverse.node);
  return new Token(node, address, contractInterface);
}

type Provider = ethers.providers.Provider | ethers.Signer;

export class Token implements IToken {
  private provider: Provider;
  private contract: ethers.Contract;

  constructor(provider: Provider, address: string, contractInterface: ethers.ContractInterface) {
    this.contract = new ethers.Contract(address, contractInterface, provider);
    this.provider = provider;
  }

  public totalSupply() {
    return this.contract.totalSupply();
  }
  public balanceOf(address: string) {
    return this.contract.balanceOf(address);
  }
  public transfer(to: string, amount: number) {
    return this.contract.transfer(to, amount);
  }
  public allowance(owner: string, spender: string) {
    return this.contract.allowance(owner, spender);
  }
  public approve(spender: string, amount: number) {
    return this.contract.approve(spender, amount);
  }
  public transferFrom(from: string, to: string, amount: number) {
    return this.contract.transferFrom(from, to, amount);
  }
  public claimOwner() {
    return this.contract.claimOwner();
  }
  public claim(referral: string) {
    return this.contract.claim(referral);
  }
  public withdraw() {
    return this.contract.withdraw();
  }
  public usingSigner() {
    return this.provider instanceof ethers.Signer;
  }
  public addToken(symbol: string, image: string) {
    const params = {
      type: "ERC20", // Initially only supports ERC20, but eventually more!
      options: {
        address: this.contract.address, // The address that the token is at.
        symbol: symbol, // A ticker symbol or shorthand, up to 5 chars.
        decimals: metaverse.decimals, // The number of decimals in the token
        image: image, // A string url of the token logo
      },
    };

    // @ts-ignore
    return this.provider.provider.send(`wallet_watchAsset`, params);
  }

  private signer() {
    return this.provider as ethers.Signer;
  }
}
